import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import {
  ReviewStructure,
  REVIEW_SUBFEATURES
} from "src/app/services/features-by-plan/interface/reviews";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { CommonService } from "../../services/common.service";
import { DATE_FORMATS } from "./../../services/utils";

@Component({
  selector: "app-analytics-monthly-goal-reviews",
  templateUrl: "./analytics-monthly-goal-reviews.component.html",
  styleUrls: ["./analytics-monthly-goal-reviews.component.scss"],
})
export class AnalyticsMonthlyGoalReviewsComponent implements OnInit {
  @Input() is_whatsapp_connected: string;
  @Input() reviewSetupData: any;
  DATE_FORMATS = DATE_FORMATS;
  public loading = false;
  private BASE_URL = GlobalVariable;
  // outlet_id: String;
  outlet_id = this.storage.get("outlet_id");
  searchText: string;
  items_per_page: number = 25;
  p: number = 1;
  // page: any;

  page_per_item_list: any = [
    { value: 5 },
    { value: 10 },
    { value: 25 },
    { value: 50 },
    { value: 75 },
    { value: 100 },
  ];
  item_list: any = [];
  show_stats: boolean = true;
  revreqtit = "Review Request stats";
  role: string = this.storage.get("role");
  manager_list: any;
  channel_list: any[] = [];
  followed_list: any;
  team: string = "";
  tag_member: string = "";
  channel: string = "";
  is_followed: string = "";

  team1: string = "";
  tag_member1: string = "";
  is_followed1: string = "";
  url1: any;
  start_date1: String;
  end_date1: String;

  show_component: Boolean;
  downbtndisabled: Boolean = false;
  downbtndisablednodata: Boolean = false;
  downloadexcelurl: any;
  analfilterdate: String;
  totalAnalyticsCount: any;
  getData: any;
  is_reviews_blocked: any;
  reviews_warning_text: any = "";
  searchText1: String;
  reviewFeatures: ReviewStructure = {
    insights_downloadable_report: [
      "feature_reviews",
      REVIEW_SUBFEATURES.insights_downloadable_report,
      "is_applicable",
    ],
  };
  @Output() onApplyFilterEvent: EventEmitter<any> = new EventEmitter();
  private _analyticsData: any;

  @Input()
  set analyticsData(value) {
    this._analyticsData = value;
  }
  get analyticsData() {
    return this._analyticsData;
  }
  // @ViewChild ('reviewstats') reviewstats;
  // scrollById(){
  //   if(this.reviewstats) this.reviewstats.nativeElement.scrollIntoView(true);
  //   }

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    private toastrService: ToastrService,
    private commonservice: CommonService
  ) {}

  ngOnChanges() {
    this.channel_list.map((e) => {
      if (e.id == "WhatsApp") {
        e.isAvailable = this.is_whatsapp_connected == "true" || false;
      }
      return e;
    });
  }

  ngOnInit() {
    this.storage.set("page", this.p);
    this.storage.set("size", this.items_per_page);
    this.commonDataServiceFunction();
    this.channel_list = [
      { id: "SMS", name: "SMS", isAvailable: true },
      { id: "Email", name: "Email", isAvailable: true },
      { id: "QR_Code", name: "QR Code", isAvailable: true },
      {
        id: "WhatsApp",
        name: "WhatsApp",
        isAvailable: this.is_whatsapp_connected === "true",
      },
    ];
    this.followed_list = [
      { id: "true", name: "Followed" },
      { id: "false", name: "Not Followed" },
    ];
    this.getAnalyticsList();
    this.getReviewsSetting();
    console.log(this.analyticsData, "analytics data");

    // this.commonservice.analytics_filter.subscribe((res) => {
    //   if (res !== null) {
    //     this.item_list = [];
    //     console.log("filter ", res);

    //     if (res["obj"].requests.length === 0) {
    //       this.show_stats = false;
    //       this.downbtndisablednodata = true;
    //     } else {
    //       this.collection = res["obj"].requests;
    //       // res['obj'].requests.forEach((val: any, key: any) => {
    //       this.show_stats = true;
    //       this.downbtndisablednodata = false;
    //       this.totalAnalyticsCount = res["total_review_request_count"];
    //     }
    //   }
    // });

    this.commonservice.analytics_filter_reset.subscribe((res) => {
      if (res !== null) {
        this.team = "";
        this.tag_member = "";
        this.channel = "";
        this.is_followed = "";
        this.team1 = null;
        this.is_followed1 = null;
        this.tag_member1 = null;
      }
    });
  }
  getReviewsSetting() {
    // this.HttpService.get(this.BASE_URL.REVIEW_SETUP_VALUE_URL_V2(this.outlet_id)).subscribe(res => {
    this.is_reviews_blocked = this.reviewSetupData["is_product_blocked"];
    this.reviews_warning_text = this.reviewSetupData["product_warning_text"];
    console.log(this.is_reviews_blocked);
    // })
  }

  getAnalyticsList() {
    // this.spinnerService.show();
    let res: Response;
    // this.outlet_id = this.storage.get('outlet_id');
    // const data_service = this.HttpService.getRequest(this.BASE_URL.ANALYTICS_OVERALL_RESET, this.outlet_id);
    const data_service = this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.ANALYTICS_OVERALL_RESET(this.outlet_id),
      page: this.p.toString(),
      size: this.items_per_page.toString(),
      // keyword: this.searchText === "" ? null : this.searchText
    });
    // data_service.subscribe((data: Response) => {

    //   res = data;
    //   console.log('res', res);
    this.totalAnalyticsCount = this.analyticsData["total_review_request_count"];
    if (this.analyticsData["obj"].requests.length === 0) {
      this.show_stats = false;
      this.downbtndisablednodata = true;
    } else {
      // this.collection = this.analyticsData["obj"].requests;
      this.show_stats = true;
      this.downbtndisablednodata = false;
    }
    this.loading = false;

    // }, error => {

    // }, () => {

    // });
  }
  onPageChange(event) {
    this.p = event;
    this.analyticsFilter();
  }
  itemsPerPageChange() {
    this.onPageChange(this.p);
  }

  commonDataServiceFunction() {
    let res: Response;
    let outlet_id = this.storage.get("outlet_id");
    this.HttpService.get(this.BASE_URL.MANAGER_LIST_API(outlet_id)).subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        // console.log(error);
      },
      () => {
        let data: any = [];
        data = res.data;
        this.manager_list = res.data;
        data.forEach((val: any, key: any) => {
          this.manager_list[key]["manager_first_name"] =
            val.owner_id === undefined
              ? val.manager_first_name
              : val.owner_first_name;
          this.manager_list[key]["manager_id"] =
            val.owner_id === undefined ? val.manager_id : val.owner_id;
          this.manager_list[key]["manager_last_name"] =
            val.owner_id === undefined
              ? val.manager_last_name
              : val.owner_last_name;
        });
      }
    );
    // this.HttpService.get(this.BASE_URL.MANAGER_API).subscribe((data: Response) => {
    //   res = data;
    // }, error => {
    // }, () => {
    //   if (res.code === 200 || res.code === 201) {
    //     this.manager_list = res.data;
    //   }
    // });
  }

  onApplyFilter() {
    let page = this.p.toString();
    let size = this.items_per_page.toString();
    let team_member = this.team;
    let channel = this.channel;
    let keyword = this.searchText;
    let is_followed = this.is_followed;
    let tag_member = this.tag_member;
    let filters = {
      page,
      size,
      team_member,
      channel,
      keyword,
      is_followed,
      tag_member,
    };
    this.onApplyFilterEvent.emit(filters);
  }

  onResetFilter() {
    this.p = 1;
    this.items_per_page = 25;
    this.team = null;
    this.channel = null;
    this.searchText = "";
    this.is_followed = null;
    this.tag_member = null;
    this.onApplyFilter();
  }

  analyticsFilter() {
    // this.loading = true;
    console.log(this.onApplyFilter());

    let start_date: string;
    let to_date: string;
    let keyWord: String;
    let keyWord2: String;
    let res: Response;
    let team: string;
    let channel: string;
    let followed: string;
    let tag_member: string;
    let url: any;
    let list_of_item: any = [];
    let team2: String;
    let is_followed2: String;
    let tag_member2: String;
    let page: String;
    let size: String;
    this.outlet_id = this.storage.get("outlet_id");
    if (this.team === undefined || this.team === "") {
      team = null;
      this.team1 = null;
      team2 = null;
      this.storage.set("team2", team2);
    } else {
      team = this.team;
      this.team1 = this.team;
      team2 = this.team;
      this.storage.set("team2", team2);
    }
    if (this.channel === undefined || this.channel === "") {
      channel = null;
      this.storage.set("channel2", channel);
    } else {
      channel = this.channel;
      this.storage.set("channel2", channel);
    }
    if (this.searchText === undefined || this.searchText === "") {
      keyWord = null;
      this.searchText1 = null;
      keyWord2 = null;
      this.storage.set("keyWord2", keyWord2);
    } else {
      keyWord = this.searchText;
      this.searchText1 = this.searchText;
      keyWord2 = this.searchText;
      this.storage.set("keyWord2", keyWord2);
    }
    if (this.is_followed === undefined || this.is_followed === "") {
      followed = null;
      this.is_followed1 = null;
      is_followed2 = null;
      this.storage.set("is_followed2", is_followed2);
    } else {
      followed = this.is_followed;
      this.is_followed1 = this.is_followed;
      is_followed2 = this.is_followed;
      this.storage.set("is_followed2", is_followed2);
    }
    if (this.tag_member === undefined || this.tag_member === "") {
      tag_member = null;
      this.tag_member1 = null;
      tag_member2 = null;
      this.storage.set("tag_member2", tag_member2);
    } else {
      tag_member = this.tag_member;
      this.tag_member1 = this.tag_member;
      tag_member2 = this.tag_member;
      this.storage.set("tag_member2", tag_member2);
    }

    (page = this.p.toString()), this.storage.set("page", page);

    (size = this.items_per_page.toString()), this.storage.set("size", size);
    console.log(page, size);

    start_date = this.storage.get("start_date");
    to_date = this.storage.get("to_date");
    this.start_date1 = start_date;
    this.end_date1 = to_date;
    if (start_date !== null && to_date !== null) {
      url = this.BASE_URL.ANALYTICS_OVERALL_FILTER(this.outlet_id);
    } else {
      url = this.BASE_URL.ANALYTICS_OVERALL_RESET(this.outlet_id);
    }
    const data_service = this.HttpService.analyticsSliceAndDice(
      url,
      team,
      channel,
      followed,
      tag_member,
      start_date,
      to_date,
      page,
      size,
      keyWord
    );
    data_service.subscribe(
      (data: Response) => {
        this.loading = false;
        res = data;
      },
      (error) => {
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.item_list = [];
        console.log("dhfkhdjkhjk");

        if (url === "/review/request/feed") {
          list_of_item = res.data["requests"];
          console.log("list_of_item", list_of_item);
        } else {
          if (res.data["obj"].requests.length === 0) {
            this.show_stats = false;
            this.downbtndisablednodata = true;
          } else {
            this.show_stats = true;
            this.downbtndisablednodata = false;
            list_of_item = res.data["obj"].requests;
            this.totalAnalyticsCount = res.data["total_review_request_count"];
            console.log("from insights");
          }
        }
        console.log(list_of_item);
        if (list_of_item.length !== 0) {
          // this.collection = list_of_item;
        }
        // if (this.collection.length === 0) {
        //   this.show_stats = true;
        //   this.downbtndisablednodata = true;
        // } else {
        //   this.show_stats = false;
        //   this.downbtndisablednodata = false;
        // }
        // console.log(this.collection);
      }
    );
  }

  DownloadReport() {
    this.downbtndisabled = true;
    let res: Response;
    let start_date: string;
    let to_date: string;
    let team: string;
    let channel: string;
    let followed: string;
    let tag_member: string;
    let url: any;
    let page: any;
    let size: any;

    start_date = this.storage.get("start_date");
    to_date = this.storage.get("to_date");

    (page = this.p.toString()),
      (size = this.items_per_page.toString()),
      console.log(page, size);

    team = this.team1;
    channel = this.channel;
    followed = this.is_followed1;
    tag_member = this.tag_member1;
    url = this.BASE_URL.DOWNLOAD_STATS_REPORT(this.outlet_id);
    console.log(channel);

    this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.DOWNLOAD_STATS_REPORT(this.outlet_id),
      team_member: team || null,
      channel: channel || null,
      source: null,
      is_followed: followed || null,
      tag_member: tag_member || null,
      start_date: start_date || null,
      end_date: to_date || null,
      keyword: this.searchText || null,
    }).subscribe((data: Response) => {
      // this.HttpService.get(this.BASE_URL.DOWNLOAD_STATS_REPORT, this.outlet_id, data_json).subscribe((data: Response) => {
      res = data;
      // console.log('data',res);
      if (res.code === 200 || res.code == 201) {
        this.toastrService.success(res.data.message);
        this.downbtndisabled = false;
      } else {
        this.downbtndisabled = false;
      }
    });
  }
}
